import classNames from "classnames";
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";

export const BgWrapper = ({
  children,
  className = "",
  onClick = () => {},
  loading = false,
  loaderHeight = 24,
  ...otherProps
}: {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
  loading?: boolean;
  loaderHeight?: number;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div
      className={classNames(`w-full rounded-2xl bg-white p-3 ${className}`, {
        "!block": loading,
      })}
      onClick={loading ? () => {} : onClick}
      {...otherProps}
    >
      {!loading && children}
      {loading && (
        <Skeleton
          width={"100%"}
          height={loaderHeight}
          className="w-full rounded-2xl"
          baseColor={SKELETON_BASE_COLOR}
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
        />
      )}
    </div>
  );
};
